const PROOF_REPORT_ARTIFACT_PREFIX = "proof-report:";

export function proofReportArtifactId(childSessionId: string): string {
  return `${PROOF_REPORT_ARTIFACT_PREFIX}${childSessionId}`;
}

export function proofRoundArtifactId(
  childSessionId: string,
  runId: string,
): string {
  return `${proofReportArtifactId(childSessionId)}:${runId}`;
}

/** Where a settled report lives once a newer run replaces it; null when it has no round key. */
export function earlierRoundArtifactId(artifact: {
  childSessionId: string;
  roundId?: string;
  run: { run_id?: string };
}): string | null {
  const round = artifact.roundId ?? artifact.run.run_id;
  return round === undefined
    ? null
    : proofRoundArtifactId(artifact.childSessionId, round);
}

/** `"proof-report:ses_1"` → `"ses_1"`; null for any other artifact id. */
export function proofReportChildId(artifactId: string | null): string | null {
  if (!artifactId?.startsWith(PROOF_REPORT_ARTIFACT_PREFIX)) return null;
  return (
    artifactId.slice(PROOF_REPORT_ARTIFACT_PREFIX.length).split(":")[0] || null
  );
}
